import React from 'react'
import {Media} from "reactstrap";
import dateHelpers from "../../helpers/DateHelper";
import Button from "reactstrap/es/Button";

import {MdDelete} from 'react-icons/md';
import {MdEdit} from 'react-icons/md';

const propTypes = {};

class CashierReportRow extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            cashier: props.cashier,
            currency: props.currency
        };

    }

    startTotal() {
        return this.state.currency + " " +(parseFloat(this.state.cashier.start_total) / 100).toFixed(2);
    }

    dayTotal() {
        return this.state.currency + " " +(parseFloat(this.state.cashier.total) / 100).toFixed(2);
    }

    render() {
        return (
            <tr>
                <th scope="row">
                    <Media className="align-items-center">
                        <Media>
                            <span className="mb-0 text-sm">
                                {this.state.cashier && this.state.cashier.date ? dateHelpers.databaseDate(this.state.cashier.date) : ""}
                            </span>
                        </Media>
                    </Media>
                </th>
                <td>
                    <span className="mb-0 text-sm">
                        {this.startTotal()}
                    </span>
                </td>
                <td>
                    <span className="mb-0 text-sm">
                     {this.dayTotal()}
                    </span>
                </td>
                <td className="text-right align-content-end">
                    <Button
                        onClick={e => this.props.onCashierDelete(e, this.state.cashier)}
                        size="sm"
                        color="danger"
                    >
                        <MdDelete/>
                    </Button>

                    <Button
                        onClick={e => this.props.onCashierEdit(e, this.state.cashier)}
                        size="sm"
                        color="warning"
                    >
                        <MdEdit/>
                    </Button>
                </td>
            </tr>
        )
    }

    price() {
        return this.state.currency + (parseFloat(this.state.cashier && this.state.cashier.price ? this.state.cashier.price : "0") * this.state.cashier.qty).toFixed(2)
    }
}

CashierReportRow.propTypes = propTypes;

export default CashierReportRow;